import { useForm, useFieldArray } from "react-hook-form";
import CreateCustomer from "./CreateCustomerForm";
import Modal from "../Reusable/Modal";
import Form from "../../layouts/Form";
import CourierOrderForm from "./CourierOrderForm";
import LogisticOrderForm from "./LogisticOrderForm";
import Button from "../Reusable/Button";
import { useEffect } from "react";
import { getApiData } from "../../helpers/AxiosInstance";
import APIS from "../../constant/EndPoint";
import { useHotkeys } from 'react-hotkeys-hook';
import { toast } from "react-toastify";
import moment from "moment";

const CreateOrder = (props: any) => {
  const {
    handleCreate,
    isLoading,
    handleCreateCustomer,
    createCustomerLoading,
    defaultBranch,
    openAddReceiverPopup,
    setOpenAddReceiverPopup,
    openAddSenderPopup,
    setOpenAddSenderPopup,
    openPrintPopup,
    setOpenPrintPopup,
    profile,
    handleLabelPrintDownload,
    handleOrderReceiptDownload,
    isPrintLoading,
    clientType,
    calculateDeliveryCharge,
    isDeliveryChargeCalculating
  } = props;

  const {
    control,
    register,
    handleSubmit,
    getValues,
    reset,
    watch,
    setError,
    setValue,
    clearErrors,
    formState: { errors }
  } = useForm({
    defaultValues: async () => {
      return {
        vendor: null,
        receiver: null,
        sender: null,
        pickup_branch: defaultBranch,
        destination: null,
        cod: 0,
        order_value: 0,
        service_type: null,
        payment_method: null,
        reference_date: moment().format('YYYY-MM-DD'),
        reference_type: null,
        reference_number: null,
        note: "",
        delivery_charge: "",
        order_items: [
          {
            package_type: null,
            weight: 1,
            piece: 1
          }
        ]
      }
    }
  });


  const { fields, append, remove } = useFieldArray({
    control,
    name: "order_items"
  });

  const handleClosePrintPopup = () => {
    setOpenPrintPopup(false)
    document.getElementsByTagName("input")[0].focus()
    reset({
      vendor: null,
      receiver: null,
      sender: null,
      pickup_branch: defaultBranch,
      destination: null,
      cod: 0,
      order_value: 0,
      service_type: null,
      payment_method: null,
      reference_date: moment().format('YYYY-MM-DD'),
      reference_type: null,
      reference_number: null,
      delivery_charge: null,
      order_items: [
        {
          package_type: null,
          weight: 1,
          piece: 1
        }
      ],
      note: "",
    })
  }

  const vendor = watch("vendor")
  const handleSetDefaultValue = async (merchantId: string) => {
    const url = `${APIS.MERCHANT}${merchantId}/`
    const res = await getApiData(url, {});
    if (res.status === 200) {
      setValue("sender", res?.data?.default_sender)
      setValue("receiver", res?.data?.default_receiver)
      setValue("service_type", res?.data?.default_service_type)
      setValue("payment_method", res?.data?.default_payment_method)
    }
  }
  useEffect(() => {
    if (vendor) {
      handleSetDefaultValue(vendor)
    }
  }, [vendor])

  const handleSetDeliveryCharge = async () => {
    if (!getValues()["destination"]) {
      toast.error("Destination is missing")
      return
    }
    if (!getValues()["service_type"]) {
      toast.error("Service Type is missing")
      return
    }
    if (!getValues()["payment_method"]) {
      toast.error("Payment method is missing")
      return
    }
    let orderItems = getValues()["order_items"].filter((item) => item.package_type !== null)
    if (!orderItems.length) {
      toast.error("Sub order is missing")
      return
    }
    const url = `${APIS.ORDER}get-delivery-charge/`;
    let formData = {
      form_data: getValues()
    };
    try {
      const res = await calculateDeliveryCharge({ url, formData });
      if (res.status === 200) {
        setValue("delivery_charge", res?.data?.charge)
      } else {
        toast.error("Delivery charge not found")
      }
    } catch (err) {
      console.log(err);
    }
  }
  useHotkeys('f1', () => {
    handleSetDeliveryCharge()
  })


  return (
    <>
      <Form
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isLoading}
      >
        {clientType?.type === "logistic" ?
          <LogisticOrderForm
            profile={profile}
            clearErrors={clearErrors}
            errors={errors}
            register={register}
            setValue={setValue}
            getValues={getValues}
            watch={watch}
            openAddReceiverPopup={openAddReceiverPopup}
            setOpenAddReceiverPopup={setOpenAddReceiverPopup}
            openAddSenderPopup={openAddSenderPopup}
            setOpenAddSenderPopup={setOpenAddSenderPopup}
            fields={fields}
            append={append}
            remove={remove}
            handleSetDeliveryCharge={handleSetDeliveryCharge}
          /> : <CourierOrderForm
            profile={profile}
            clearErrors={clearErrors}
            errors={errors}
            register={register}
            setValue={setValue}
            getValues={getValues}
            watch={watch}
            openAddReceiverPopup={openAddReceiverPopup}
            setOpenAddReceiverPopup={setOpenAddReceiverPopup}
            openAddSenderPopup={openAddSenderPopup}
            setOpenAddSenderPopup={setOpenAddSenderPopup}
            fields={fields}
            append={append}
            remove={remove}
          />}
      </Form>

      <Modal
        isOpen={openAddReceiverPopup}
        setIsOpen={setOpenAddReceiverPopup}
        title={"Craeate Receiver"}
        children={<>
          <CreateCustomer
            handleCreate={handleCreateCustomer}
            isLoading={createCustomerLoading}
          />
        </>} />
      <Modal
        isOpen={openAddSenderPopup}
        setIsOpen={setOpenAddSenderPopup}
        title={"Create Sender"}
        children={<>
          <CreateCustomer
            handleCreate={handleCreateCustomer}
            isLoading={createCustomerLoading}
          />
        </>} />

      <Modal
        isOpen={openPrintPopup}
        setIsOpen={handleClosePrintPopup}
        title={"Print "}
        children={<div>
          <Button label={"Print Label"} isLoading={isPrintLoading} disabled={isPrintLoading} onClick={handleLabelPrintDownload} />
          <Button label={"Print Receipt"} isLoading={isPrintLoading} disabled={isPrintLoading} onClick={handleOrderReceiptDownload} />
        </div>} />
    </>

  )
};

export default CreateOrder;
